<template>
    <div>
        <Table
            class="margin-top-20"
            :loading="loading"
            :columns="columns"
            :data="dataList"
            size="small"
            ref="table"
            border
        ></Table>
        <footer class="text-right margin-top-10">
            <Button type="primary" @click="submit">{{
                $t("global.common.update_OK", { defaultValue: "确定" })
            }}</Button>
            <Button class="margin-left-10" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compMutiUpload
                :action="props.action"
                :name="props.name"
                :multiple="false"
                :data="props.data"
                @on-success="success"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>
<script>
import {
    HttpSkuChangeLabelList,
    HttpSkuChangeLabelSaveAll,
} from "@/service/boss/distribution";

export default {
    props: ["orderItemData", "id"],
    data() {
        return {
            loading: false,
            dataList: [],
            index: 0,
            operate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            props: {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.id || 0,
                    model: "deliverorder",
                    type: "other",
                },
            },
        };
    },
    computed: {
        columns() {
            const _this = this;
            return [
                {
                    title: "ERP SKU",
                    key: "erpsku",
                },
                {
                    title: "New Barcode",
                    key: "newLabel",
                    render(h, { row, index }) {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.newLabel,
                            },
                            on: {
                                input: (event) => {
                                    row.newLabel = event;
                                    _this.dataList[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    title: "Label",
                    key: "labelUrl",
                    render(h, { row, index }) {
                        if (row.labelUrl) {
                            return (
                                <div>
                                    <a
                                        type="primary"
                                        size="small"
                                        on-click={() =>
                                            window.open(row.labelUrl)
                                        }
                                    >
                                        {row.labelUrl.split("/").pop()}
                                    </a>
                                </div>
                            );
                        } else {
                            return <div>--</div>;
                        }
                    },
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    width: 80,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "info",
                                        size: "small",
                                    },
                                    style: {
                                        marginRight: "5px",
                                    },
                                    on: {
                                        click: () => {
                                            _this.propFile(index);
                                        },
                                    },
                                },
                                _this.$t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    created() {
        HttpSkuChangeLabelList({ deliverOrderId: this.id }).then(
            (res) => {
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        let label = {
                            id: res.data[i].id,
                            deliverOrderId: this.id,
                            erpsku: res.data[i].erpsku,
                            newLabel: res.data[i].newLabel,
                            labelUrl: res.data[i].labelUrl,
                        };
                        this.dataList.push(label);
                    }
                } else {
                    // 对 orderItemData 去重
                    const seenErpsku = new Set();

                    for (let i = 0; i < this.orderItemData.length; i++) {
                        // 如果 erpsku 已经存在，跳过
                        if (seenErpsku.has(this.orderItemData[i].erpsku)) {
                            continue;
                        }
                        seenErpsku.add(this.orderItemData[i].erpsku);
                        let label = {
                            deliverOrderId: this.id,
                            erpsku: this.orderItemData[i].erpsku,
                            newLabel: "",
                            labelUrl: "",
                        };
                        this.dataList.push(label);
                    }
                }
            },
            (err) => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            }
        );
    },
    methods: {
        success(res) {
            if (res) {
                this.dataList[this.index].labelUrl =
                    res.originData[0].entity.url;
            }
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        propFile(index) {
            this.index = index;
            this.operate.show = true;
        },
        cancel() {
            this.$emit("on-close");
        },
        async submit() {
            this.loading = true;
            await HttpSkuChangeLabelSaveAll({
                skuChangeLabelEntityList: this.dataList,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-close");
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
